import { getOsControlSymbol } from 'app-ui/utilities';

const getHotkeyHintKey = (key: string) => {
  switch (key) {
    case 'mod':
      return getOsControlSymbol();
    case 'esc':
    case 'escape':
      return 'Esc';
    default:
      return key.toUpperCase();
  }
};

// 'mod+k' becomes ['⌘', 'K'] on macOS and ['Ctrl', 'K'] elsewhere; the
// sequence 'g h' becomes ['G', 'H'].
export const getHotkeyHintKeys = (keys: string) =>
  keys
    .split(' ')
    .flatMap((sequenceStep) => sequenceStep.split('+'))
    .map(getHotkeyHintKey);
